import { reactive } from "vue";
import { defineStore } from "pinia";
import { TFeatures } from "../api/features/types";

type TState = {
  features: TFeatures;
};

export const useFeaturesStore = defineStore("features", () => {
  const state: TState = reactive({
    features: {
      aiPlaygroundWizard: false,
      autopilotBatchWizardAccess: false,
      briefsWizardAccess: false,
      briefsWorkflowLimit: 0,
      companyInfoInputsEnabled: false,
      contactAutomationWizard: false,
      emailAiEnabled: false,
      emailFollowUp: false,
      importMeetingRecordings: false,
      importMeetingRecordingsArchiveAfterDays: 0,
      importMeetingRecordingsDeleteAfterDays: 0,
      meetingAccessUnrestricted: false,
      meetingBotRecordAudioOnly: false,
      retroPilotWizard: false,
    },
  });

  function setAllFeatures(features: TFeatures): void {
    state.features = features;
  }

  return { state, setAllFeatures };
});
